import React from "react";
import PropTypes from "prop-types";
import { DeleteIcon } from "wm-graphics";
import "./SelectedOption.scss";

export class SelectedOption extends React.Component {
  static propTypes = {
    onSelectedClick: PropTypes.func,
    selectedOption: PropTypes.shape({
      label: PropTypes.string,
      id: PropTypes.number,
    }),
  };

  render() {
    const { onSelectedClick, selectedOption } = this.props;
    return (
      <div
        className="SearchBar__SelectedOption"
        onClick={onSelectedClick}
        onKeyDown={this.onKeyDown}
        tabIndex={0}
        role="button"
      >
        <div className="SelectedOption__label">{selectedOption.label}</div>
        <DeleteIcon height={10} width={10} />
      </div>
    );
  }
}

export default SelectedOption;
